import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import { set } from "date-fns";
import Exitoso from "../Exitoso";
import Error from "../Error";

import { BASE_URL } from "../../../utils/index";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function LoadingServicio(props) {
  useEffect(() => {
    const requestHandle = async () => {
      //   //   //Data
      const {
        tipo,
        direccionHospital,
        fechaCompletaEnviar,
        idPrimerPaciente,
        primerPaciente,
        puebloPrimerPaciente,
        direccionPrimerPaciente,
        telfPrimerPaciente,
        telfPrimerPaciente2,
        NASS1,
        idSegundoPaciente,
        segundoPaciente,
        puebloSegundoPaciente,
        direccionSegundoPaciente,
        telfSegundoPaciente,
        telfSegundoPaciente2,
        NASS2,
        destino,
        email,
        password,
        idCliente,
        idClienteSol,
        perfilLog,
        urgente,
        peritoneal,
        alta,
        ingres,
      } = props.values;
      let csrfToken = localStorage.getItem("csrfToken");
      let response = await fetch(`${BASE_URL}/pedirViajeQuimioterapia`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": csrfToken, // Adjuntar el token CSRF como encabezado
        },
        body: JSON.stringify({
          email: email,
          password: password,
          fecha: fechaCompletaEnviar,
          tipo: tipo,
          idPrimerPaciente: idPrimerPaciente,
          primerPaciente: primerPaciente,
          puebloPrimerPaciente: puebloPrimerPaciente.title,
          telfPrimerPaciente: telfPrimerPaciente,
          telfPrimerPaciente2:
            telfPrimerPaciente2 !== "" ? telfPrimerPaciente2 : "NO",
          direccionPrimerPaciente: direccionPrimerPaciente,
          NASS1: NASS1,
          idSegundoPaciente: idSegundoPaciente,
          segundoPaciente: segundoPaciente,
          puebloSegundoPaciente: puebloSegundoPaciente.title,
          telfSegundoPaciente: telfSegundoPaciente,
          telfSegundoPaciente2:
            telfSegundoPaciente2 !== "" ? telfSegundoPaciente2 : "NO",
          direccionSegundoPaciente: direccionSegundoPaciente,
          NASS2: NASS2,
          direccionHospital: direccionHospital.title,
          idCliente: Number(perfilLog) === 5 ? idClienteSol.id : idCliente,
          destino: destino.title,
          urgente: urgente,
          peritoneal: peritoneal,
          alta: alta,
          ingres: ingres,
        }),
      });
      let response2 = await response.json();
      console.log(response2);
      const { message, id } = response2;
      if (id === "FOUND") {
        if (message !== undefined || message != null) {
          setStateComponent({
            ...stateComponent,
            isLoading: false,
            isSuccess: true,
            message: message,
            id: id,
          });
        } else {
          setStateComponent({
            ...stateComponent,
            isError: true,
          });
        }
      } else {
        if (message !== undefined || message != null) {
          setStateComponent({
            ...stateComponent,
            isLoading: false,
            isSuccess: true,
            message: message,
          });
        } else {
          setStateComponent({
            ...stateComponent,
            isError: true,
          });
        }
      }
    };
    requestHandle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const classes = useStyles();

  const [stateComponent, setStateComponent] = useState({
    isLoading: true,
    isSuccess: false,
    isError: false,
    message: "",
    id: "",
  });

  if (stateComponent.isLoading)
    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );
  if (stateComponent.id === "FOUND") {
    return <Exitoso message={stateComponent.message} id={stateComponent.id} />;
  } else {
    if (stateComponent.isSuccess) {
      return (
        <Exitoso message={stateComponent.message} id={stateComponent.id} />
      );
    }
  }

  if (stateComponent.isError) {
    return <Error />;
  }
}
